if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        popStateHandler: null,
        init() {
          this.popStateHandler = (event) => {
            if (event.state?.xPagination?.[sectionId]) window.location.reload();
          };
          window.addEventListener('popstate', this.popStateHandler);
          this.restoreLoadedPages();
        },
        destroy() {
          window.removeEventListener('popstate', this.popStateHandler);
        },
        async loadMore(event) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.loading) return;
          const url = event.currentTarget.href;
          const loaded = await this.loadData(url);
          if (loaded) {
            this.updateHistory(url);
          } else {
            window.location.assign(url);
          }
        },
        async loadData(url) {
          this.loading = true;
          try {
            const response = await fetch(url);
            if (!response.ok) return false;
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const productGrid = html.getElementById('items-grid');
            if (!productGrid) return false;
            const newProducts = Array.from(productGrid.querySelectorAll('.grid-item'));
            const target = document.getElementById('blog-grid') || document.getElementById('items-grid');
            if (!target) return false;
            for (let i = 0; i < newProducts.length; i++) {
              if (i > 0) await new Promise(r => setTimeout(r, 300));
              const item = newProducts[i];
              item.classList.add('x-pagination-slide-up');
              target.appendChild(item);
              requestAnimationFrame(() => {
                requestAnimationFrame(() => item.classList.add('x-pagination-slide-up--in'));
              });
            }
            this._renderButton(html);
            return true;
          } catch (e) {
            console.error(e);
            return false;
          } finally {
            this.loading = false;
          }
        },
        async restoreLoadedPages() {
          const state = history.state?.xPagination?.[sectionId];
          if (!state || !Array.isArray(state.pageUrls) || state.pageUrls.length < 2) return;

          const currentUrl = new URL(window.location.href);
          const stateUrl = new URL(state.pageUrls[state.pageUrls.length - 1], window.location.origin);
          if (currentUrl.pathname !== stateUrl.pathname || currentUrl.search !== stateUrl.search) return;

          this.loading = true;
          try {
            const pages = await Promise.all(state.pageUrls.slice(0, -1).map(async (url) => {
              const response = await fetch(url);
              if (!response.ok) throw new Error(`Unable to restore pagination page: ${response.status}`);
              const text = await response.text();
              const html = new DOMParser().parseFromString(text, 'text/html');
              const productGrid = html.getElementById('items-grid');
              if (!productGrid) throw new Error('Unable to restore pagination grid');
              return Array.from(productGrid.querySelectorAll('.grid-item'));
            }));
            const target = document.getElementById('blog-grid') || document.getElementById('items-grid');
            if (!target) return;
            const fragment = document.createDocumentFragment();
            pages.flat().forEach((item) => fragment.appendChild(item));
            target.prepend(fragment);
          } catch (error) {
            console.error(error);
          } finally {
            this.loading = false;
          }
        },
        updateHistory(url) {
          const state = history.state || {};
          const pagination = state.xPagination || {};
          const current = pagination[sectionId] || { pageUrls: [window.location.href] };

          if (!pagination[sectionId]) {
            history.replaceState({
              ...state,
              xPagination: {
                ...pagination,
                [sectionId]: current
              }
            }, '', window.location.href);
          }

          const pageUrls = [...current.pageUrls];
          if (pageUrls[pageUrls.length - 1] !== url) pageUrls.push(url);
          history.pushState({
            ...history.state,
            xPagination: {
              ...(history.state?.xPagination || {}),
              [sectionId]: { pageUrls }
            }
          }, '', url);
        },
        _renderButton(html) {
          const destination = document.getElementById(`btn-pagination-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
